module.exports = __webpack_public_path__ + "static/08-204dc53e20c0d0575b67373dc48d2e64.jpg";